import { useCallback, useRef } from "react";

export function useTouchGateSetter<T>(
    setTouched: (b: boolean) => void,
    setValue: (v: T) => void,
    options?: { onlyWhen?: (v: T) => boolean }
) {
    const onlyWhenRef = useRef(options?.onlyWhen ?? (() => true));
    onlyWhenRef.current = options?.onlyWhen ?? (() => true);

    return useCallback(
        (v: T) => {
            if (onlyWhenRef.current(v)) setTouched(true);
            setValue(v);
        },
        [setTouched, setValue]
    );
}
